import Navbar from "./components/navbar";
import gsap from "gsap";
import Lightbox from "./components/lightbox";
import { SliderInit, SliderDestroyOnDesktop } from "./components/slider";
import ReloadOnResize from "./helpers/resize";

// body js class
document.documentElement.className = document.documentElement.className.replace("no-js", "js");

// Header / Menu
const hamburgerIcon = document.querySelector("#hamburger-button") ?? false;
const menu = document.querySelector("#site-header-main") ?? false;
if (hamburgerIcon && menu) Navbar(hamburgerIcon, menu);

// Slider init for post slider page
const glide = document.querySelector("#post-slider .glide") ?? false;
if (glide) SliderInit(glide);

// Slider for post simple page
const postSimpleGlide = document.querySelector("#post-simple .glide") ?? false;
if (postSimpleGlide) SliderDestroyOnDesktop(postSimpleGlide)

// Lightbox
const postImage = document.querySelector(".post__image") ?? false;
if (postImage) Lightbox();

// Lightbox
const glightbox = document.querySelector(".glightbox") ?? false;
if (glightbox) Lightbox();

// Reload on breakpoint SM/MD
ReloadOnResize();

// Transition effect
const transitionItems = [...document.querySelectorAll(".transition")] ?? false;
if (transitionItems) gsap.to(transitionItems, { opacity: 1, stagger: 0.25 })


// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

